// index.ts - Main entry point that loads the appropriate bootstrap based on environment

/**
 * Determines which bootstrap file to load based on environment variables
 */
const loadBootstrap = async () => {
  // Get environment from process.env
  const environment = process.env.REACT_APP_ENV || 'local';

  try {
    console.log(`Loading bootstrap for environment: ${environment}`);

    // Import the appropriate bootstrap module based on environment
    let bootstrapModule;

    if (environment === 'local') {
      // Load dev bootstrap
      bootstrapModule = await import('./bootstrap.dev');

      // For local bootstrap that has default export but no named 'bootstrap' export
      if (!bootstrapModule.bootstrap && typeof bootstrapModule.default === 'function') {
        await bootstrapModule.default();
        return;
      }
    } else {
      // Load build/production bootstrap
      bootstrapModule = await import('./bootstrap.build');
    }

    // Call the bootstrap function from the loaded module
    if (bootstrapModule.bootstrap) {
      await bootstrapModule.bootstrap();
    } else {
      console.error('No bootstrap function found in the imported module');
      throw new Error('Invalid bootstrap module structure');
    }
  } catch (err) {
    console.error('Critical bootstrap error:', err);
    // Render basic error message if bootstrap fails
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.innerHTML = '<div>Failed to load application. Please refresh the page.</div>';
    }
  }
};

// Execute the bootstrap loader
loadBootstrap();

export {};
